










































































































































import { Component, Vue } from "vue-property-decorator";
import AbpBase from '@/lib/abpbase'
import CustomForm from "@/components/custom-form/index.vue";
import PicModal from "@/components/upload/picModal.vue";
import ProductFilter from "../productFilter/index.vue";
import MemberScope from "../memberScope/index.vue";
import RewardPointActivityApi from "@/api/marketing/rewardPointActivity/index";
import Mission from "./mission.vue";
import GetRuleConfig from "./model/getRuleConfig";
@Component({
  components: {
    CustomForm,
    PicModal,
    ProductFilter,
    Mission,
    MemberScope
  }
})
export default class RewardPointActivity extends AbpBase {
  currentTab: string = "basicForm";
  activityId: string = "";
  productTabVisible: boolean = false;
  ruleValidate = {
    name: [{ required: true, message: "活动标题不能为空", trigger: "blur" }],
    beginTime: [
      {
        required: true,
        type: "date",
        message: "请选择开始日期",
        trigger: "change"
      }
    ],
    endTime: [
      {
        required: true,
        type: "date",
        message: "请选择结束日期",
        trigger: "change"
      }
    ]
  };

  ruleValidate3 = {
    imageUrl: [
      {
        validator: (rule, value, callback) => {
          if (this.formItem.disseminateConfig.showOnHomePage) {
            if (!value) {
              callback("请选择弹窗图片");
            }
          }
          callback();
        },
        trigger: "change"
      }
    ]
  };
  validNumber(rule, value, callback) {
    if (value <= 0) {
      callback(new Error("必须大于0"));
    }
    callback();
  }
  validTierDiscount(rule, value, callback) {
    // console.log(
    //   "valid tier discount",
    //   this.formItem.ruleConfig.tierDiscountConfig
    // );
    // this.formItem.ruleConfig.tierDiscountConfig.tierDiscounts.forEach(
    //   element => {
    //     if (element.condition === null || element.discount === null) {
    //       callback(new Error("优惠条件不能为空"));
    //     }
    //   }
    // );
    callback();
  }
  formItem = {
    name: "",
    beginTime: null,
    endTime: null,
    type: "",
    ruleConfig: {},
    disseminateConfig: {
      ribbon: "",
      showOnHomePage: false,
      imageUrl: "",
      copyWriting: "",
      promotionImage: []
    },
    productFilterConfig: {
      scope: "condition",
      brands: [],
      categories: [],
      years: [],
      season: [],
      price: {
        min: 0,
        max: 0
      },
      discount: {
        min: 0,
        max: 0
      },
      productIds: []
    }
  };
  get ruleConfigValidate() {
    if (this.formItem.type === "limitDiscount") {
      return {
        discount: [
          {
            required: true,
            message: "折扣必须大于0",
            validator: this.validNumber,
            trigger: "blur"
          }
        ]
      };
    }
    if (this.formItem.type === "buyGetOne") {
      return {
        quantity: [
          {
            required: true,
            message: "起送件数必须大于0",
            validator: this.validNumber,
            trigger: "blur"
          }
        ]
      };
    }
    if (this.formItem.type === "tierDiscount") {
      return {
        tierDiscounts: [
          {
            required: true,
            validator: this.validTierDiscount,
            trigger: "blur"
          }
        ]
      };
    }
    if (this.formItem.type === "freeShipping") {
      return {
        value: [
          {
            required: true,
            message: "必须大于0",
            validator: this.validNumber,
            trigger: "blur"
          }
        ]
      };
    }
    if (this.formItem.type === "preSales") {
      return {
        balancePayStartTime: [
          {
            required: true,
            type: "date",
            message: "请选择开始日期",
            trigger: "change"
          }
        ],
        balancePayEndTime: [
          {
            required: true,
            type: "date",
            message: "请选择结束日期",
            trigger: "change"
          }
        ],
        expriedTime: [
          {
            required: true,
            message: "订单失效时间必须大于0",
            validator: this.validNumber,
            trigger: "blur"
          }
        ]
      };
    }
    if (this.formItem.type === "group") {
      return {
        limitCount: [
          {
            required: true,
            message: "参团次数必须大于0",
            validator: this.validNumber,
            trigger: "blur"
          }
        ],
        expriedTime: [
          {
            required: true,
            message: "拼团过期时间必须大于0",
            validator: this.validNumber,
            trigger: "blur"
          }
        ]
      };
    }
    if (this.formItem.type === "secKill") {
      return {
        expriedTime: [
          {
            required: true,
            message: "订单失效时间必须大于0",
            validator: this.validNumber,
            trigger: "blur"
          }
        ]
      };
    }
    return null;
  }
  get computeRuleConfig() {
    let obj = this.formItem.ruleConfig;
    return obj;
  }
  async mounted() {
    this.formItem.type = this.$route.meta.promotionType;
    if (this.formItem.type === "limitRewardPointExchange") {
      this.productTabVisible = true;
    }
    if (this.$route.query.id !== undefined) {
      this.activityId = this.$route.query.id.toString();
      await this.loadActivity();
    } else {
      this.formItem.ruleConfig = GetRuleConfig(this.formItem.type);
    }
  }
  async loadActivity() {
    await RewardPointActivityApi.getRewardPointActivity(this.activityId).then(
      res => {
        console.log(res);
        this.formItem = res.data;
        this.formItem.beginTime = new Date(res.data.beginTime);
        this.formItem.endTime = new Date(res.data.endTime);
        this.formItem.type = this.$route.meta.promotionType;
      }
    );
  }
  removeShareImg(index: number) {
    this.formItem.disseminateConfig.promotionImage.splice(index, 1);
  }
  imageUrlChange(list) {
    this.formItem.disseminateConfig.imageUrl = list[0].url;
  }
  promotionImageChange(list) {
    list.forEach(item => {
      this.formItem.disseminateConfig.promotionImage.push(item.url);
    });
  }
  save() {
    var valid1 = (this.$refs["basicForm"] as any).validate();
    var valid2 =
      (this.$refs["ruleConfigForm"] as any).rules === null
        ? new Promise(resolver => resolver(true))
        : (this.$refs["ruleConfigForm"] as any).validate();

    var valid3 = this.isVicutuProject ? (this.$refs["disseminateForm"] as any).validate() : new Promise(resolver => resolver(true));

    Promise.all([valid1, valid2, valid3]).then(values => {
      console.log("values", values);
      var index = values.findIndex(x => x === false);
      //   return;
      if (index > -1) {
        if (index === 0) this.currentTab = "basicForm";
        if (index === 1) this.currentTab = "ruleConfigForm";
        if (index === 2) this.currentTab = "disseminateForm";
      } else {
        console.log("提交");
        if (this.activityId === "") {
          RewardPointActivityApi.addRewardPointActivity(this.formItem).then(
            res => {
              console.log("add promotion activity", res);
              this.$Message.success("保存成功");
              this.$router.push({
                name: this.formItem.type
              });
            }
          );
        } else {
          RewardPointActivityApi.updateRewardPointActivity(
            this.activityId,
            this.formItem
          ).then(res => {
            this.$Message.success("保存成功");
            this.$router.push({
              name: this.formItem.type
            });
          });
        }
      }
    });
  }
}
